module.exports = __webpack_public_path__ + "static/media/st_icon.9457a606.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/st_icon.png
// module id = 2176
// module chunks = 0